export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    id: 'cat-1',
    name: '平台指南',
    slug: 'platform-guide',
    description: '开云体育平台使用教程、注册登录指引及常见操作说明',
    icon: 'ri-guide-line',
  },
  {
    id: 'cat-2',
    name: '赛事资讯',
    slug: 'sports-news',
    description: '最新体育赛事动态、赛程安排与精彩赛事回顾',
    icon: 'ri-football-line',
  },
  {
    id: 'cat-3',
    name: '活动福利',
    slug: 'promotions',
    description: '开云体育平台优惠活动、充值福利及会员权益详解',
    icon: 'ri-gift-line',
  },
  {
    id: 'cat-4',
    name: '常见问题',
    slug: 'faq',
    description: '开云体育常见问题解答，帮助您快速解决使用疑问',
    icon: 'ri-question-answer-line',
  },
];